import { ErrorLogComponent } from '@cian/error-log-component';
import { useToggleState } from '@cian/react-utils';

import { type JSX } from 'react';

import { useListingAppContext } from '@/microfrontends/listing/shared/context/ListingAppContext';
import { useCardOfferDataContext } from '@/microfrontends/listing/shared/context/selectors/cardData';

import { memoWithDisplayName } from '@/packages/react-utils/memoWithDisplayName';
import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';
import { PortalEventStoper } from '@/packages/shared-ui';
import { stopPropagation } from '@/packages/utils/event/stopPropagation';

import { CardContactsButtonDesktopContainer } from '../CardContactsButtonContainer';
import { type DisplayPhonesOptions } from '../CardContactsButtonContainer/types';
import { CardJoinElectronicTradingButtonContainer } from '../CardJoinElectronicTradingButtonContainer';

import { Controls, ControlsShort } from './components/Controls';
import { More } from './components/More';
import { ComparisonContainer } from './containers/ComparisonContainer';
import { ComplaintContainer } from './containers/ComplaintContainer';
import { DownloadPDFContainer } from './containers/DownloadPDFContainer';
import { FavoriteContainer } from './containers/FavoriteContainer';
import { HideContainer } from './containers/HideContainer';
import {
  MenuItemChatsContainer,
  MenuItemComplaintContainer,
  MenuItemDownloadPDFContainer,
  MenuItemHideOfferContainer,
} from './containers/MenuItems';

const displayPhonesOptions: DisplayPhonesOptions = {
  countToDisplay: 1,
  shouldDisplayWorkHours: false,
};

export const CardControlsContainer = memoWithDisplayName(() => {
  const { config, logger } = useListingAppContext();
  const isNarrow = useListingLayoutIsNarrowSelector();
  const popoverVisibilityState = useToggleState();
  const { tradingLink } = useCardOfferDataContext();

  /**
   * @todo Удалить фича-тогл
   * @description Данный функционал появился в задаче CD-187914, будет удалён в задаче CD-188067
   */
  const electronicTradingEnabled = config.getStrict<boolean>('search-frontend.ElectronicTrading.Enabled');

  let content: JSX.Element;

  const callToActionButton = ((): JSX.Element => {
    if (electronicTradingEnabled && tradingLink) {
      return <CardJoinElectronicTradingButtonContainer buttonText="К торгам" />;
    }

    return <CardContactsButtonDesktopContainer displayPhonesOptions={displayPhonesOptions} />;
  })();

  if (isNarrow) {
    content = (
      <>
        <PortalEventStoper>{callToActionButton}</PortalEventStoper>
        <ControlsShort onClick={stopPropagation}>
          <FavoriteContainer isVisible={popoverVisibilityState.state} tooltipPlacement="top" />
          <More popoverPlacement="top-end" popoverVisibilityState={popoverVisibilityState} tooltipPlacement="top">
            <MenuItemChatsContainer />
            <MenuItemComplaintContainer />
            <MenuItemHideOfferContainer />
            <MenuItemDownloadPDFContainer />
          </More>
        </ControlsShort>
      </>
    );
  } else {
    content = (
      <Controls onClick={stopPropagation}>
        <FavoriteContainer isVisible />
        <ComparisonContainer />
        <HideContainer />
        <ComplaintContainer />
        <DownloadPDFContainer />
      </Controls>
    );
  }

  return (
    <ErrorLogComponent level="error" logger={logger}>
      {content}
    </ErrorLogComponent>
  );
}, 'Controls');
